import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

export const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  containerCard: {
    display: 'flex',
    flexDirection: 'column',
  },
  divider: {
    margin: 30,
  },
  sectionRadioGroup: {
    margin: 5,
  },
  selectorsContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
    marginTop: '20px',
    paddingBottom: '50px',
    alignItems: 'center',
    flexWrap: 'wrap',
    position: 'relative'
  },
  cardLegend: {
    justifyContent: 'center',
    margin: 20,
  },
  labelDate: {
    fontSize: '14px',
    margin: '16px 0 4px 0'
  },
  btnClear: {
    position: 'absolute',
    bottom: 0,
    right: '25px',
     '&:focus': {
      boxShadow: 'none'
    }
  },
  containerMaterialsBtn: {
    position: 'relative'
  },
  btnInfoMaterials: {
    width: '32px',
    height: '32px',
    padding: 0,
    borderRadius: '50%',
    position: 'absolute',
    top: '10px',
    right: '-50px',
    color: 'white',
    cursor: 'pointer'
  }
}));



export const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);
